import Navbar from './components/Navbar';
import Hero from './components/Hero';
import RankWall from './components/RankWall';
import NewsFeed from './components/NewsFeed';
import Timeline from './components/Timeline';
import FeatureRail from './components/FeatureRail';
import BuzzWall from './components/BuzzWall';
import Subscribe from './components/Subscribe';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <RankWall />
        <NewsFeed />
        <Timeline />
        <FeatureRail />
        <BuzzWall />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}